// Qué mostrar cuando el núcleo no inicia un lote (POST /api/direct_debit/start y /start_special).
// Un 400 o un success:false es una regla de negocio (banco o producto sin contrato CT, ordenante CT incompleto):
// se muestra el mensaje del servidor como aviso, no como error (Mario, 29-oct: «parece un error y no el mensaje
// bien explicado de que pasa»). Prueba: test/domiciliacion-aviso-inicio-lote.test.mjs

export interface AvisoInicioLote {
  tipo: 'aviso' | 'error';
  mensaje: string;
}

export const MENSAJE_RESPALDO = 'No se pudo generar el lote. Intenta de nuevo y, si se repite, avisa a tecnología.';

const texto = (v: any): string => (typeof v === 'string' && v.trim() && !v.trim().startsWith('<') && v.length <= 500 ? v.trim() : '');

export const avisoInicioLote = (error: any): AvisoInicioLote => {
  const esHttp = typeof error?.status === 'number';
  const cuerpo = esHttp ? error.error : error;
  const mensaje = texto(cuerpo?.description) || texto(cuerpo?.msg) || texto(cuerpo);
  if (!mensaje) return { tipo: 'error', mensaje: MENSAJE_RESPALDO };
  const esRegla = esHttp ? error.status === 400 : cuerpo?.success === false;
  return { tipo: esRegla ? 'aviso' : 'error', mensaje };
};
